import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: false,
};

const irrigationTypeSlice = createSlice({
  name: "irrigationType",
  initialState,
  reducers: {
    // create
    createIrrigationTypeStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    createIrrigationTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    createIrrigationTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetCreateIrrigationTypeState(state) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // update
    updateIrrigationTypeStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    updateIrrigationTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    updateIrrigationTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetUpdateIrrigationTypeState(state) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
    // delete
    deleteIrrigationTypeStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    deleteIrrigationTypeSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    deleteIrrigationTypeFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
    resetDeleteIrrigationTypeState(state) {
      state.data = [];
      state.isLoading = false;
      state.error = null;
      state.success = false;
    },
  },
});

export const {
  createIrrigationTypeStart,
  createIrrigationTypeSuccess,
  createIrrigationTypeFailure,
  resetCreateIrrigationTypeState,
  updateIrrigationTypeStart,
  updateIrrigationTypeSuccess,
  updateIrrigationTypeFailure,
  resetUpdateIrrigationTypeState,
  deleteIrrigationTypeStart,
  deleteIrrigationTypeSuccess,
  deleteIrrigationTypeFailure,
  resetDeleteIrrigationTypeState,
} = irrigationTypeSlice.actions;

export default irrigationTypeSlice.reducer;
